export const french_dictionary = {
  "Last update": "Dernière mise à jour",
  "Unknown": "Inconnu",
  "Clear": "Temps clair",
  "Mostly Clear": "Peu nuageux",
  "Partly Cloudy": "Variable",
  "Mostly Cloudy": "Très nuageux",
  "Cloudy": "Nuageux",
  "Fog": "Brouillard",
  "Light Fog": "Léger brouillard",
  "Drizzle": "Bruine",
  "Rain": "Pluie",
  "Light Rain": "Pluie faible",
  "Heavy Rain": "Pluie forte",
  "Snow": "Neige",
  "Flurries": "Averses de neige",
  "Light Snow": "Neige faible",
  "Heavy Snow": "Neige forte",
  "Freezing Drizzle": "Bruine verglaçante",
  "Freezing Rain": "Pluie verglaçante",
  "Light Freezing Rain": "Pluie faible verglaçante",
  "Heavy Freezing Rain": "Pluie forte verglaçante",
  "Ice Pellets": "Grésil",
  "Heavy Ice Pellets": "Grésil fort",
  "Light Ice Pellets": "Grésil faible",
  "Thunderstorm": "Orageux",
  "Now": "Maintenant",
  "Forecast": "Météo"
}
